module.exports = "/images/extra-phone.svg?64fcc2f1eff5c5271e8e7e1f52edfb07";